import React from 'react'

const shimmerStyle = {
  background: 'linear-gradient(90deg, transparent 0%, rgba(128,128,128,0.15) 20%, rgba(128,128,128,0.25) 50%, rgba(128,128,128,0.15) 80%, transparent 100%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 1.5s infinite',
}

const ShimmerKeyframes = () => (
  <style>{`@keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }`}</style>
)

export const Skeleton = ({ width, height = 16, rounded = 'rounded-lg', className = '' }) => (
  <>
    <ShimmerKeyframes />
    <div
      data-testid="skeleton"
      className={`${rounded} ${className}`}
      style={{ ...shimmerStyle, width: width ?? '100%', height }}
    />
  </>
)

export const SkeletonText = ({ lines = 1, width, className = '' }) => (
  <>
    <ShimmerKeyframes />
    <div className={`flex flex-col gap-2 ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          data-testid="skeleton-line"
          className="rounded-md h-[14px]"
          style={{ ...shimmerStyle, width: i === lines - 1 && lines > 1 ? '60%' : (width ?? '100%') }}
        />
      ))}
    </div>
  </>
)

export const SkeletonCard = ({ children, className = '' }) => (
  <div className={`border border-divider rounded-2xl p-5 bg-surface shadow-subtle dark:shadow-none ${className}`}>
    {children}
  </div>
)
